import React from "react";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
import ColDynamic from "../WrapperComponents/ColDynamic";

import InputComponent from "../../UI/InputComponent/InputComponent";
import WorkAddress from "../WorkAddress/WorkAddress";
import BasicAddressData from "../BasicAddressData/BasicAddressData";
import ButtonComponent from "../../UI/ButtonComponent/ButtonComponent";
import DropDown from "../../UI/Dropdown/Dropdown";

const AuditCompanyBoardMember = (props) => {
  const auditCompanyBoardMember = props.parentState.newFormData.auditCompanyBoardMember.find(
    (element) => element.id === props.id
  );

  const arrayLength =
    props.parentState.newFormData.auditCompanyBoardMember.length > 1;

  const { oibValidated } = auditCompanyBoardMember;

  let dropDownData = props.parentState.newFormData.dropDownData.map(
    (element) => (
      <option key={element.id} value={element.id}>
        {element.value}
      </option>
    )
  );

  const mapFunkcijaValue = (nazivFunkcije) => {
    switch (nazivFunkcije) {
      case "Direktor":
        return 3;
      case "Predsjednik uprave":
        return 4;
      case "Član uprave":
        return 5;
      case "Prokurist":
        return 6;
      case "Član upravnog odbora":
        return 7;
      default:
        break;
    }
  }

  return (
    <div>
      <Row>
        <Col>
          <InputComponent
            minLength={11}
            maxLength={11}

            onChange={props.mappedUserInputHandler}
            objData={{ id: props.id, group: "auditCompanyBoardMember" }}
            value={auditCompanyBoardMember.oib}
            id={`audit-board-member-oib${props.id}`}
            name="oib"
            controlLabel="OIB"
          />
          {!oibValidated &&
            auditCompanyBoardMember.oib.length <= 11 &&
            auditCompanyBoardMember.oib.length > 0 && (
              <p style={{ color: "red" }}>Oib nije ispravan!</p>
            )}
        </Col>
        <Col>
          {/* <InputComponent
            required
            style={
              props.required &&
              props.parentState.error &&
              auditCompanyBoardMember.funkcija.length < 1 &&
              "red"
            }
            onChange={props.mappedUserInputHandler}
            objData={{ id: props.id, group: "auditCompanyBoardMember" }}
            value={auditCompanyBoardMember.funkcija}
            id={`audit-board-member-funkcija${props.id}`}
            name="funkcija"
            controlLabel="Funkcija"
          /> */}
          <DropDown
            required
            style={
              props.required &&
              props.parentState.error &&
              auditCompanyBoardMember.funkcija.length < 1 &&
              "red"
            }
            id={`audit-board-memebr-funkcija${props.id}`}
            label={props.required ? "Funkcija*" : "Funkcija"}
            hidden
            asProperty="select"
            map={dropDownData}
            text="Odaberite funkciju"
            value={mapFunkcijaValue(auditCompanyBoardMember.funkcija)}
            onChange={props.funkcijaDropDownHandler}
          >
          </DropDown>
        </Col>
      </Row>
      <Row>
        <Col>
          <InputComponent
            required
            style={
              props.required &&
              props.parentState.error &&
              auditCompanyBoardMember.prezime.length < 1 &&
              "red"
            }
            onChange={props.mappedUserInputHandler}
            objData={{ id: props.id, group: "auditCompanyBoardMember" }}
            value={auditCompanyBoardMember.prezime}
            id={`audit-board-member-prezime${props.id}`}
            name="prezime"
            controlLabel="Prezime"
          />
        </Col>

        <Col>
          <InputComponent
            required
            style={
              props.required &&
              props.parentState.error &&
              auditCompanyBoardMember.ime.length < 1 &&
              "red"
            }
            onChange={props.mappedUserInputHandler}
            objData={{ id: props.id, group: "auditCompanyBoardMember" }}
            value={auditCompanyBoardMember.ime}
            id={`audit-board-member-ime${props.id}`}
            name="ime"
            controlLabel="Ime"
          />
        </Col>
      </Row>
      {props.showBrRegOrig && (
        <Row>
          <Col>
            <InputComponent
              onChange={props.mappedUserInputHandler}
              objData={{ id: props.id, group: "auditCompanyBoardMember" }}
              value={auditCompanyBoardMember.brRegOrig}
              id={`audit-board-member-brRegOrig${props.id}`}
              name="brRegOrig"
              controlLabel="Registarski broj iz registra revizora u trećoj zemlji"
            />
          </Col>
          <Col></Col>
        </Row>
      )}
      <BasicAddressData
        required
        hackId="audit-board-member"
        requiredKbr={props.requiredKbr}
        objData={{ id: props.id, group: "auditCompanyBoardMember" }}
        onChange={props.mappedUserInputHandler}
        address={auditCompanyBoardMember}
        {...props}
      />

      <Row>
        <ColDynamic className="col-lg-4">

          {props.parentState.newFormData.auditCompanyBoardMember.length -1 === props.idZaBtn ? 
            <ButtonComponent
              id={`audit-board-member-multiply-btn${props.id}`}
              onClick={(e) =>
                props.multiplyComponent(e, {
                  formGroup: "auditCompanyBoardMember",
                })
              }
            >
              Dodaj novi
          </ButtonComponent>
            : null
          }
          
        </ColDynamic>
        <ColDynamic className="col-lg-4">
          {arrayLength && (
            <ButtonComponent
              variant="danger"
              id={`audit-board-member-remove-btn${props.id}`}
              onClick={(e) =>
                props.removeComponentHandler(e, {
                  formGroup: "auditCompanyBoardMember",
                })
              }
            >
              Ukloni 
            </ButtonComponent>
          )}
        </ColDynamic>
      </Row>
    </div>
  );
};

export default AuditCompanyBoardMember;
